export default __webpack_public_path__ + "static/media/close2.2001e956.svg";